var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogox2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2-2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 68,
    viewBox: "0 0 128 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -19.683,
    y1: -1.955,
    x2: -0.723,
    y2: 0.351,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ffa608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9e0b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -10.553,
    y1: -1.935,
    x2: 0.114,
    y2: 0.415,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -6.876,
    y1: -1.828,
    x2: 0.447,
    y2: 0.503,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -4.935,
    y1: -1.798,
    x2: 0.623,
    y2: 0.552,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -3.765,
    y1: -1.734,
    x2: 0.728,
    y2: 0.619,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2.958,
    y1: -1.666,
    x2: 0.8,
    y2: 0.688,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2.385,
    y1: -1.577,
    x2: 0.854,
    y2: 0.747,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1.946,
    y1: -1.508,
    x2: 0.893,
    y2: 0.823,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -1.606,
    y1: -1.421,
    x2: 0.923,
    y2: 0.885,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -1.335,
    y1: -1.392,
    x2: 0.947,
    y2: 0.962,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -1.109,
    y1: -1.296,
    x2: 0.966,
    y2: 1.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -0.921,
    y1: -1.22,
    x2: 0.985,
    y2: 1.086,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -0.766,
    y1: -1.163,
    x2: 1,
    y2: 1.157,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.627,
    y1: -1.066,
    x2: 1.012,
    y2: 1.211,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -0.51,
    y1: -0.994,
    x2: 1.022,
    y2: 1.273,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -0.406,
    y1: -0.984,
    x2: 1.031,
    y2: 1.369,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -0.396,
    y1: -0.952,
    x2: 1.045,
    y2: 1.358,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -0.46,
    y1: -1.002,
    x2: 1.057,
    y2: 1.352,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -0.532,
    y1: -1.027,
    x2: 1.074,
    y2: 1.326,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -0.616,
    y1: -1.02,
    x2: 1.091,
    y2: 1.289,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -0.707,
    y1: -1.07,
    x2: 1.112,
    y2: 1.273,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -0.818,
    y1: -1.088,
    x2: 1.137,
    y2: 1.243,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -0.953,
    y1: -1.164,
    x2: 1.164,
    y2: 1.239,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -1.108,
    y1: -1.137,
    x2: 1.197,
    y2: 1.191,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -1.277,
    y1: -1.159,
    x2: 1.235,
    y2: 1.165,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -1.5,
    y1: -1.194,
    x2: 1.281,
    y2: 1.141,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -1.766,
    y1: -1.237,
    x2: 1.335,
    y2: 1.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -2.13,
    y1: -1.258,
    x2: 1.417,
    y2: 1.096,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -2.549,
    y1: -1.268,
    x2: 1.507,
    y2: 1.063,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -3.171,
    y1: -1.262,
    x2: 1.637,
    y2: 1.026,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -4.052,
    y1: -1.373,
    x2: 1.821,
    y2: 1.026,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -5.385,
    y1: -1.34,
    x2: 2.109,
    y2: 0.984,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -7.911,
    y1: -1.402,
    x2: 2.651,
    y2: 0.966,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -13.255,
    y1: -1.429,
    x2: 3.77,
    y2: 0.939,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -13.267,
    y1: -0.754,
    x2: 3.758,
    y2: 0.775,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    y1: 0.752,
    x2: 0.31,
    y2: 0.415,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e555ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e242ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.703,
    y1: 0.742,
    x2: -0.259,
    y2: -0.158,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#7c74ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8471b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b064d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#c260e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 0.415,
    y1: 1.04,
    x2: 0.57,
    y2: 0.674,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bd4ce2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf31e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.597,
    y1: 0.581,
    x2: 0.089,
    y2: 0.219,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b35bd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ea73ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -1.946,
    y1: 3.675,
    x2: 1.918,
    y2: -1.162,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ff7416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc002"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -2.457,
    y1: 4.241,
    x2: 2.218,
    y2: -1.581,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -2.651,
    y1: 4.692,
    x2: 2.326,
    y2: -1.879,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -2.718,
    y1: 4.821,
    x2: 2.366,
    y2: -1.95,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -2.784,
    y1: 4.909,
    x2: 2.404,
    y2: -2.024,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -2.824,
    y1: 4.978,
    x2: 2.427,
    y2: -2.066,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -2.852,
    y1: 5.033,
    x2: 2.443,
    y2: -2.104,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -2.878,
    y1: 5.107,
    x2: 2.458,
    y2: -2.151,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -2.893,
    y1: 5.12,
    x2: 2.467,
    y2: -2.162,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -2.896,
    y1: 5.108,
    x2: 2.469,
    y2: -2.151,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -2.913,
    y1: 5.135,
    x2: 2.479,
    y2: -2.173,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -2.922,
    y1: 5.138,
    x2: 2.483,
    y2: -2.176,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -2.934,
    y1: 5.148,
    x2: 2.49,
    y2: -2.178,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -2.948,
    y1: 5.16,
    x2: 2.499,
    y2: -2.184,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -2.956,
    y1: 5.172,
    x2: 2.503,
    y2: -2.193,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -2.962,
    y1: 5.171,
    x2: 2.507,
    y2: -2.191,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -2.968,
    y1: 5.178,
    x2: 2.51,
    y2: -2.195,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -2.974,
    y1: 5.188,
    x2: 2.514,
    y2: -2.199,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -2.973,
    y1: 5.2,
    x2: 2.513,
    y2: -2.209,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -2.977,
    y1: 5.204,
    x2: 2.515,
    y2: -2.212,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -2.979,
    y1: 5.217,
    x2: 2.517,
    y2: -2.217,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -2.982,
    y1: 5.215,
    x2: 2.518,
    y2: -2.217,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -2.983,
    y1: 5.241,
    x2: 2.519,
    y2: -2.233,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -2.983,
    y1: 5.242,
    x2: 2.519,
    y2: -2.234,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -2.986,
    y1: 5.255,
    x2: 2.521,
    y2: -2.24,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -2.983,
    y1: 5.255,
    x2: 2.519,
    y2: -2.239,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -2.984,
    y1: 5.26,
    x2: 2.52,
    y2: -2.243,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -2.986,
    y1: 5.259,
    x2: 2.521,
    y2: -2.242,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -2.998,
    y1: 5.253,
    x2: 2.526,
    y2: -2.24,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -3.01,
    y1: 5.21,
    x2: 2.531,
    y2: -2.219,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -3.003,
    y1: 5.175,
    x2: 2.525,
    y2: -2.193,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -3.007,
    y1: 5.103,
    x2: 2.52,
    y2: -2.154,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -3.067,
    y1: 4.844,
    x2: 2.543,
    y2: -2.003,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -3.012,
    y1: 4.048,
    x2: 2.472,
    y2: -1.419,
    xlinkHref: "#linear-gradient-40"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M1188.386,67.33l-.076.464h-.671l.374-.464Z",
    transform: "translate(-1101.489 -62.461)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M1177.389,81l-.339.455h1.238l.089-.455Z",
    transform: "translate(-1091.667 -75.143)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M1166.5,94.49l-.348.458h1.845l.088-.44Z",
    transform: "translate(-1081.558 -87.657)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M1155.475,108.22l-.344.455h2.474l.072-.455Z",
    transform: "translate(-1071.339 -100.395)",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M1144.693,121.71l-.344.454h3.06l.09-.454Z",
    transform: "translate(-1061.339 -112.909)",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M1133.678,135.38l-.348.454h3.689l.076-.454Z",
    transform: "translate(-1051.119 -125.591)",
    fill: "url(#linear-gradient-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M1122.757,148.78l-.357.454,4.3.006.07-.46Z",
    transform: "translate(-1040.983 -138.022)",
    fill: "url(#linear-gradient-7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M1111.744,162.48l-.344.458h4.905l.08-.458Z",
    transform: "translate(-1030.78 -150.731)",
    fill: "url(#linear-gradient-8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M1100.885,175.9l-.355.462h5.5l.095-.463Z",
    transform: "translate(-1020.699 -163.181)",
    fill: "url(#linear-gradient-9)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M1090.009,189.64l-.349.454h6.116l.085-.454Z",
    transform: "translate(-1010.617 -175.927)",
    fill: "url(#linear-gradient-10)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M1079.118,203.06l-.358.461h6.725l.1-.461Z",
    transform: "translate(-1000.507 -188.376)",
    fill: "url(#linear-gradient-11)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M1068.059,216.82l-.349.464h7.336l.089-.464Z",
    transform: "translate(-990.259 -201.142)",
    fill: "url(#linear-gradient-12)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M1057.32,230.24l-.36.461h7.914l.1-.461Z",
    transform: "translate(-980.289 -213.591)",
    fill: "url(#linear-gradient-13)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M1046.32,243.91l-.361.469,8.54,0,.093-.466Z",
    transform: "translate(-970.087 -226.273)",
    fill: "url(#linear-gradient-14)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M1035.517,257.26l-.357.471h9.14l.1-.471Z",
    transform: "translate(-960.07 -238.657)",
    fill: "url(#linear-gradient-15)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M1024.669,270.93l-.349.454h9.748l.1-.454Z",
    transform: "translate(-950.017 -251.339)",
    fill: "url(#linear-gradient-16)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M1021.741,284.6l.187.463h9.561l.08-.463Z",
    transform: "translate(-947.624 -264.02)",
    fill: "url(#linear-gradient-17)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M1026.291,298.27l.161.454h9.078l.089-.454Z",
    transform: "translate(-951.844 -276.702)",
    fill: "url(#linear-gradient-18)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M1030.73,311.7l.178.454h8.566l.068-.454Z",
    transform: "translate(-955.961 -289.161)",
    fill: "url(#linear-gradient-19)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M1035.49,325.37l.141.463,8.052,0,.1-.46Z",
    transform: "translate(-960.376 -301.842)",
    fill: "url(#linear-gradient-20)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M1039.9,338.85l.175.455h7.522l.084-.456Z",
    transform: "translate(-964.466 -314.348)",
    fill: "url(#linear-gradient-21)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M1044.71,352.59l.192.458,6.966,0,.083-.454Z",
    transform: "translate(-968.927 -327.094)",
    fill: "url(#linear-gradient-22)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M1049.859,366.14l.185.445h6.415l.087-.445Z",
    transform: "translate(-973.703 -339.664)",
    fill: "url(#linear-gradient-23)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M1054.811,379.68l.165.459h5.9l.08-.459Z",
    transform: "translate(-978.295 -352.225)",
    fill: "url(#linear-gradient-24)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M1059.22,393.07l.176.46,5.374,0,.085-.457Z",
    transform: "translate(-982.385 -364.647)",
    fill: "url(#linear-gradient-25)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M1064.23,406.82l.191.458h4.816l.082-.458Z",
    transform: "translate(-987.032 -377.402)",
    fill: "url(#linear-gradient-26)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M1069.12,420.33l.16.448,4.315.007.088-.456Z",
    transform: "translate(-991.567 -389.936)",
    fill: "url(#linear-gradient-27)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M1074.141,433.94l.161.454h3.761l.068-.454Z",
    transform: "translate(-996.223 -402.562)",
    fill: "url(#linear-gradient-28)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M1078.58,447.37l.183.458h3.23l.076-.458Z",
    transform: "translate(-1000.341 -415.02)",
    fill: "url(#linear-gradient-29)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M1083.63,461.063l.187.445h2.667l.089-.467Z",
    transform: "translate(-1005.024 -427.702)",
    fill: "url(#linear-gradient-30)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M1088.53,474.69l.155.446h2.174l.081-.446Z",
    transform: "translate(-1009.569 -440.365)",
    fill: "url(#linear-gradient-31)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M1093.09,488.28l.17.46h1.638l.081-.46Z",
    transform: "translate(-1013.798 -452.972)",
    fill: "url(#linear-gradient-32)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M1098.021,501.83l.178.451h1.094l.068-.451Z",
    transform: "translate(-1018.371 -465.542)",
    fill: "url(#linear-gradient-33)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M1102.78,515.42l.182.451h.559l.09-.451Z",
    transform: "translate(-1022.785 -478.15)",
    fill: "url(#linear-gradient-34)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M1107,527.99h-.291l.105.244h.149Z",
    transform: "translate(-1026.43 -489.811)",
    fill: "url(#linear-gradient-35)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M1110.059,38.432,1127.87,9.215,1133.487,0l-17.1,4.772Z",
    transform: "translate(-1029.536)",
    fill: "url(#linear-gradient-36)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M1361.208,0l-5.618,9.215,29.667,17.4Z",
    transform: "translate(-1257.256)",
    fill: "url(#linear-gradient-37)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M517.662,612.71l12.331,16.075L498.51,636.4Z",
    transform: "translate(-462.348 -568.404)",
    fill: "url(#linear-gradient-38)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M0,608l36.183,24.035,7.524-9.308Z",
    transform: "translate(0 -564.035)",
    fill: "url(#linear-gradient-39)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M925.71,829.98l.1.116-.157.085-.152-.071Z",
    transform: "translate(-858.365 -769.963)",
    fill: "url(#linear-gradient-40)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M916.762,823.27l.1.132-.446.27-.17-.086Z",
    transform: "translate(-849.786 -763.739)",
    fill: "url(#linear-gradient-41)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M907.963,817.074l-.743.454-.18-.077.819-.491Z",
    transform: "translate(-841.244 -757.885)",
    fill: "url(#linear-gradient-42)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M898.857,810.391s.106.132.106.132l-1.051.626-.192-.079,1.136-.68Z",
    transform: "translate(-832.601 -751.79)",
    fill: "url(#linear-gradient-43)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M888.67,804.845l.166.083,1.376-.817-.109-.121Z",
    transform: "translate(-824.206 -745.853)",
    fill: "url(#linear-gradient-44)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M879.48,798.46l.164.08,1.684-1-.1-.121Z",
    transform: "translate(-815.683 -739.758)",
    fill: "url(#linear-gradient-45)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M870.34,792.217l.156.079,1.993-1.179-.1-.118Z",
    transform: "translate(-807.207 -733.802)",
    fill: "url(#linear-gradient-46)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M861.19,785.985l.155.071,2.3-1.359-.108-.107Z",
    transform: "translate(-798.72 -727.855)",
    fill: "url(#linear-gradient-47)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M851.95,779.708l.152.075,2.61-1.546-.1-.107Z",
    transform: "translate(-790.15 -721.862)",
    fill: "url(#linear-gradient-48)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M842.85,773.286l.142.079,2.927-1.72-.105-.124Z",
    transform: "translate(-781.71 -715.731)",
    fill: "url(#linear-gradient-49)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M833.53,766.954l.154.082,3.223-1.906-.089-.12Z",
    transform: "translate(-773.067 -709.691)",
    fill: "url(#linear-gradient-50)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M824.41,760.643l.149.08,3.534-2.1-.1-.116Z",
    transform: "translate(-764.608 -703.662)",
    fill: "url(#linear-gradient-51)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M815.45,754.34l.133.071,3.839-2.27-.1-.121Z",
    transform: "translate(-756.298 -697.641)",
    fill: "url(#linear-gradient-52)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M806.31,747.985l.121.062,4.151-2.456-.1-.122Z",
    transform: "translate(-747.821 -691.565)",
    fill: "url(#linear-gradient-53)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M797.37,741.754l.1.06,4.473-2.642-.1-.111Z",
    transform: "translate(-739.529 -685.618)",
    fill: "url(#linear-gradient-54)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M788.22,735.367l.095.056,4.778-2.826-.112-.117Z",
    transform: "translate(-731.043 -679.514)",
    fill: "url(#linear-gradient-55)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M779.17,729.071l.085.052,5.084-3.008-.108-.116Z",
    transform: "translate(-722.649 -673.502)",
    fill: "url(#linear-gradient-56)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M770.06,722.776l.073.046,5.392-3.176-.094-.125Z",
    transform: "translate(-714.2 -667.491)",
    fill: "url(#linear-gradient-57)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M760.93,716.567l.072.048,5.7-3.362-.1-.113Z",
    transform: "translate(-705.733 -661.572)",
    fill: "url(#linear-gradient-58)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M751.89,710.261l.052.045,6.019-3.543-.1-.113Z",
    transform: "translate(-697.349 -655.551)",
    fill: "url(#linear-gradient-59)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M742.66,703.882l.052.036,6.331-3.722-.1-.116Z",
    transform: "translate(-688.788 -649.457)",
    fill: "url(#linear-gradient-60)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M733.56,697.664l.037.034,6.64-3.9-.1-.119Z",
    transform: "translate(-680.348 -643.519)",
    fill: "url(#linear-gradient-61)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M724.37,691.44l.031.028,6.966-4.08-.1-.109Z",
    transform: "translate(-671.825 -637.582)",
    fill: "url(#linear-gradient-62)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M715.25,685.109l.031.03,7.269-4.259-.1-.109Z",
    transform: "translate(-663.366 -631.543)",
    fill: "url(#linear-gradient-63)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M705.99,678.8l.025.018,7.582-4.428-.087-.118Z",
    transform: "translate(-654.778 -625.513)",
    fill: "url(#linear-gradient-64)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M696.81,672.454l.022.017,7.9-4.608-.112-.123Z",
    transform: "translate(-646.264 -619.455)",
    fill: "url(#linear-gradient-65)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M687.6,666.21l.014.02,8.219-4.793-.1-.118Z",
    transform: "translate(-637.722 -613.499)",
    fill: "url(#linear-gradient-66)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M683.97,659.6l.014.015,8.121-4.742-.1-.115Z",
    transform: "translate(-634.355 -607.414)",
    fill: "url(#linear-gradient-67)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M696.96,652.517v-.033l6.745-4.054.072.1Z",
    transform: "translate(-646.403 -601.542)",
    fill: "url(#linear-gradient-68)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M709.71,645.3l.112-.161,5.353-3.194.065.095Z",
    transform: "translate(-658.228 -595.53)",
    fill: "url(#linear-gradient-69)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M722.15,637.992l.131-.185,4.074-2.428.078.106Z",
    transform: "translate(-669.765 -589.435)",
    fill: "url(#linear-gradient-70)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M734.88,630.909l.208-.273,2.7-1.586.09.1Z",
    transform: "translate(-681.572 -583.563)",
    fill: "url(#linear-gradient-71)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M747.83,623.448l.02-.031.166-.254,1.435-.843.072.113Z",
    transform: "translate(-693.583 -577.319)",
    fill: "url(#linear-gradient-72)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M760.5,616.175l.179-.238.161-.107.083.125Z",
    transform: "translate(-705.334 -571.299)",
    fill: "url(#linear-gradient-73)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M-13.489-371.606c5.54,0,10.058-2.991,10.058-8.021,0-3.057-2.308-4.964-7.288-6.213-3.034-.855-3.99-1.512-3.99-2.7,0-1.578,2.11-2.86,4.781-2.86A13.3,13.3,0,0,1-3.7-389.949l.561-4.306a19.839,19.839,0,0,0-7.024-1.282c-5.936,0-9.959,3.123-9.959,7.692,0,3.32,2.836,5.194,7.222,6.344,3.067.888,4.089,1.611,4.089,2.794,0,1.808-2.11,2.958-4.617,2.958a13.256,13.256,0,0,1-7.749-2.564l-2.012,4.01C-21.008-372.724-16.952-371.606-13.489-371.606Zm22.544.061a18.122,18.122,0,0,0,3.7-.521l.56-5.1a7.4,7.4,0,0,1-2.95.633c-2.2,0-3.174-1.266-2.8-3.686l1.008-7.3H15.03l.635-4.43H9.2l.747-5.324H8.681l-9.449,6.627-.448,3.09H2.743l-1.232,8.9C.764-373.518,3.938-371.545,9.055-371.545Zm6.349-.521H21.23l1.307-9.493c.6-3.909,3.361-6.18,6.461-6.18A4.244,4.244,0,0,1,31.65-387l.747-4.989a8.806,8.806,0,0,0-2.988-.484,8.965,8.965,0,0,0-7.469,3.909H21.79l-2.764-3.388H18.2Zm22.744-22.449a3.584,3.584,0,0,0,3.585-3.462,2.632,2.632,0,0,0-2.838-2.606,3.607,3.607,0,0,0-3.623,3.388A2.7,2.7,0,0,0,38.148-394.516Zm-6.162,22.449h5.863l2.8-19.88H34.787Zm9.374,0h5.826l.71-5.249,2.577-2.494h.261l4.183,7.744h6.722L55.29-383.682l8.254-8.265H56.859L49.128-384.2h-.261l2.39-16.865H45.431Zm28.234-22.449a3.584,3.584,0,0,0,3.585-3.462,2.632,2.632,0,0,0-2.838-2.606,3.607,3.607,0,0,0-3.623,3.388A2.7,2.7,0,0,0,69.594-394.516Zm-6.162,22.449H69.3l2.8-19.88H66.233Zm19.644.484a15.5,15.5,0,0,0,7.843-1.973l-.3-4.207a12.01,12.01,0,0,1-6.61,1.936c-3.585,0-5.49-1.526-5.527-4.207h14.9a16.207,16.207,0,0,0,.6-3.835c0-4.914-3.473-8.6-8.777-8.6-7.918,0-11.839,7.111-11.839,12.062C73.366-375.641,76.391-371.583,83.076-371.583Zm-4.295-11.5a6.225,6.225,0,0,1,6.013-5.063,4.18,4.18,0,0,1,4.22,4.989Z",
    transform: "translate(28.478 416.896)",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M1.883-46.186a1.755,1.755,0,0,0,1.708-1.458h.357l.074-.523H2.175l-.074.523.761,0a.933.933,0,0,1-.905.8.734.734,0,0,1-.771-.791,1.236,1.236,0,0,1,1.133-1.268.961.961,0,0,1,.72.292l.395-.528a1.424,1.424,0,0,0-1.091-.407A1.981,1.981,0,0,0,.448-47.579,1.348,1.348,0,0,0,1.883-46.186Zm3.4,0a1.927,1.927,0,0,0,.975-.245l-.037-.523a1.493,1.493,0,0,1-.822.241c-.446,0-.682-.19-.687-.523H6.562a2.015,2.015,0,0,0,.074-.477,1.034,1.034,0,0,0-1.091-1.069,1.5,1.5,0,0,0-1.472,1.5A1.07,1.07,0,0,0,5.281-46.191Zm-.534-1.43a.774.774,0,0,1,.747-.629.52.52,0,0,1,.525.62Zm3.431,1.435a2.253,2.253,0,0,0,.46-.065l.07-.634a.92.92,0,0,1-.367.079c-.274,0-.395-.157-.348-.458l.125-.907h.8L9-48.722H8.2l.093-.662H8.131l-1.175.824-.056.384h.492L7.24-47.07C7.147-46.431,7.542-46.186,8.178-46.186Zm1.941-.065H11.4a1.876,1.876,0,0,0,1.843-1.823,1.293,1.293,0,0,0-1.393-1.416H10.573Zm.826-.643.274-1.958h.474a.726.726,0,0,1,.8.81,1.112,1.112,0,0,1-1.077,1.148Zm3.2-2.147a.446.446,0,0,0,.446-.43.327.327,0,0,0-.353-.324.448.448,0,0,0-.45.421A.336.336,0,0,0,14.143-49.042Zm-.766,2.791h.729l.348-2.471h-.729Zm2.177.06c.655,0,1.1-.347,1.1-.87,0-.319-.218-.537-.724-.653-.33-.088-.427-.176-.427-.3,0-.162.181-.278.464-.278a1.432,1.432,0,0,1,.636.148l.06-.5a1.889,1.889,0,0,0-.8-.143c-.622,0-1.082.324-1.082.824,0,.329.237.551.706.666.348.088.436.171.436.3,0,.2-.2.292-.474.292a1.43,1.43,0,0,1-.822-.282l-.214.528A2.269,2.269,0,0,0,15.555-46.191Zm2.683,0a1.99,1.99,0,0,0,.887-.218l.084-.629a1.624,1.624,0,0,1-.826.255.593.593,0,0,1-.669-.588.841.841,0,0,1,.826-.833.769.769,0,0,1,.594.231l.232-.537a1.234,1.234,0,0,0-.836-.282,1.536,1.536,0,0,0-1.56,1.49A1.137,1.137,0,0,0,18.238-46.186Zm2.428,0A1.518,1.518,0,0,0,22.184-47.7a1.055,1.055,0,0,0-1.161-1.083A1.516,1.516,0,0,0,19.5-47.274,1.063,1.063,0,0,0,20.666-46.186Zm.065-.565a.549.549,0,0,1-.562-.592.865.865,0,0,1,.785-.879.544.544,0,0,1,.562.583A.867.867,0,0,1,20.731-46.751Zm2.423.592h.172L24.9-48.722h-.729l-.738,1.337h-.037l-.362-1.337h-.738Zm2.683-.032a1.927,1.927,0,0,0,.975-.245l-.037-.523a1.493,1.493,0,0,1-.822.241c-.446,0-.682-.19-.687-.523h1.852a2.015,2.015,0,0,0,.074-.477A1.034,1.034,0,0,0,26.1-48.787a1.5,1.5,0,0,0-1.472,1.5A1.07,1.07,0,0,0,25.838-46.191Zm-.534-1.43a.774.774,0,0,1,.747-.629.52.52,0,0,1,.525.62Zm2.071,1.37H28.1l.162-1.18a.83.83,0,0,1,.8-.768.527.527,0,0,1,.33.093l.093-.62a1.094,1.094,0,0,0-.371-.06,1.114,1.114,0,0,0-.929.486h-.019l-.344-.421h-.1Zm3.352.06a1.927,1.927,0,0,0,.975-.245l-.037-.523a1.493,1.493,0,0,1-.822.241c-.446,0-.682-.19-.687-.523h1.852a2.015,2.015,0,0,0,.074-.477,1.034,1.034,0,0,0-1.091-1.069,1.5,1.5,0,0,0-1.472,1.5A1.07,1.07,0,0,0,30.726-46.191Zm-.534-1.43a.774.774,0,0,1,.747-.629.52.52,0,0,1,.525.62Zm3.078,1.435a1.236,1.236,0,0,0,1.04-.648h.032l-.079.588h.72l.506-3.61h-.72l-.241,1.708h-.042a.889.889,0,0,0-.868-.639,1.457,1.457,0,0,0-1.281,1.532A.962.962,0,0,0,33.271-46.186Zm.371-.588a.552.552,0,0,1-.58-.578.866.866,0,0,1,.8-.861.552.552,0,0,1,.585.574A.867.867,0,0,1,33.642-46.774Zm2.173.574a.449.449,0,0,0,.432-.384.337.337,0,0,0-.344-.393.446.446,0,0,0-.432.38A.334.334,0,0,0,35.815-46.2Zm3.51.014a1.755,1.755,0,0,0,1.708-1.458h.357l.074-.523H39.617l-.074.523.761,0a.933.933,0,0,1-.905.8.734.734,0,0,1-.771-.791,1.236,1.236,0,0,1,1.133-1.268.961.961,0,0,1,.72.292l.395-.528a1.424,1.424,0,0,0-1.091-.407,1.981,1.981,0,0,0-1.894,1.971A1.348,1.348,0,0,0,39.324-46.186Zm3.4,0a1.927,1.927,0,0,0,.975-.245l-.037-.523a1.493,1.493,0,0,1-.822.241c-.446,0-.682-.19-.687-.523H44a2.014,2.014,0,0,0,.074-.477,1.034,1.034,0,0,0-1.091-1.069,1.5,1.5,0,0,0-1.472,1.5A1.07,1.07,0,0,0,42.723-46.191Zm-.534-1.43a.774.774,0,0,1,.747-.629.52.52,0,0,1,.525.62Zm3.431,1.435a2.252,2.252,0,0,0,.46-.065l.07-.634a.92.92,0,0,1-.367.079c-.274,0-.395-.157-.348-.458l.125-.907h.8l.079-.551h-.8l.093-.662h-.158L44.4-48.56l-.056.384h.492l-.153,1.106C44.589-46.431,44.984-46.186,45.62-46.186Zm3.138,0c.78,0,1.416-.421,1.416-1.129,0-.43-.325-.7-1.026-.875-.427-.12-.562-.213-.562-.379,0-.222.3-.4.673-.4a1.873,1.873,0,0,1,.877.2l.079-.606a2.793,2.793,0,0,0-.989-.18c-.836,0-1.4.44-1.4,1.083,0,.467.4.731,1.017.893.432.125.576.227.576.393,0,.255-.3.417-.65.417a1.866,1.866,0,0,1-1.091-.361l-.283.565A2.589,2.589,0,0,0,48.758-46.186Zm1.5.958h.724l.232-1.657.037,0a.766.766,0,0,0,.808.7,1.444,1.444,0,0,0,1.3-1.527,1.01,1.01,0,0,0-1.049-1.074,1.36,1.36,0,0,0-1.082.537h-.019l-.357-.472h-.1Zm1.565-1.578a.535.535,0,0,1-.566-.555.826.826,0,0,1,.771-.824.543.543,0,0,1,.576.555A.829.829,0,0,1,51.822-46.806Zm2.948.62A1.518,1.518,0,0,0,56.288-47.7a1.055,1.055,0,0,0-1.161-1.083A1.516,1.516,0,0,0,53.6-47.274,1.063,1.063,0,0,0,54.77-46.186Zm.065-.565a.549.549,0,0,1-.562-.592.865.865,0,0,1,.785-.879.544.544,0,0,1,.562.583A.867.867,0,0,1,54.835-46.751Zm1.634.5h.724l.186-1.314a.7.7,0,0,1,.664-.653.486.486,0,0,1,.474.62l-.19,1.347h.724l.2-1.449a.916.916,0,0,0-.961-1.088,1.284,1.284,0,0,0-1,.509h-.019l-.353-.444h-.1Zm4.016.06c.655,0,1.1-.347,1.1-.87,0-.319-.218-.537-.724-.653-.33-.088-.427-.176-.427-.3,0-.162.181-.278.464-.278a1.432,1.432,0,0,1,.636.148l.06-.5a1.889,1.889,0,0,0-.8-.143c-.622,0-1.082.324-1.082.824,0,.329.237.551.706.666.348.088.436.171.436.3,0,.2-.2.292-.474.292a1.43,1.43,0,0,1-.822-.282l-.214.528A2.269,2.269,0,0,0,60.485-46.191Zm2.577,0A1.518,1.518,0,0,0,64.58-47.7a1.055,1.055,0,0,0-1.161-1.083A1.516,1.516,0,0,0,61.9-47.274,1.063,1.063,0,0,0,63.062-46.186Zm.065-.565a.549.549,0,0,1-.562-.592.865.865,0,0,1,.785-.879.544.544,0,0,1,.562.583A.867.867,0,0,1,63.127-46.751Zm1.634.5h.724l.162-1.18a.83.83,0,0,1,.8-.768.528.528,0,0,1,.33.093l.093-.62a1.094,1.094,0,0,0-.371-.06,1.114,1.114,0,0,0-.928.486h-.019l-.344-.421h-.1Zm3.352.06a1.927,1.927,0,0,0,.975-.245l-.037-.523a1.493,1.493,0,0,1-.822.241c-.446,0-.682-.19-.687-.523h1.852a2.014,2.014,0,0,0,.074-.477,1.034,1.034,0,0,0-1.091-1.069,1.5,1.5,0,0,0-1.472,1.5A1.07,1.07,0,0,0,68.113-46.191Zm-.534-1.43a.774.774,0,0,1,.747-.629.52.52,0,0,1,.525.62Zm3.078,1.435a1.236,1.236,0,0,0,1.04-.648h.033l-.079.588h.72l.506-3.61h-.72l-.241,1.708h-.042A.889.889,0,0,0,71-48.787a1.457,1.457,0,0,0-1.281,1.532A.962.962,0,0,0,70.657-46.186Zm.371-.588a.552.552,0,0,1-.58-.578.866.866,0,0,1,.8-.861.552.552,0,0,1,.585.574A.867.867,0,0,1,71.028-46.774ZM73.2-46.2a.449.449,0,0,0,.432-.384.337.337,0,0,0-.344-.393.446.446,0,0,0-.432.38A.334.334,0,0,0,73.2-46.2Z",
    transform: "translate(26.932 96.672)",
    fill: "#fff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M39.18,465.975l.242.549h5.137l.345-1.375Z",
    transform: "translate(-36.338 -431.514)",
    fill: "#fff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M46.79,374.85l2.034.378,1.069-.189Z",
    transform: "translate(-43.396 -347.744)",
    fill: "#fff"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M110.633,312.817l1.931-.121-1.3-.936-.672,1.057Z",
    transform: "translate(-102.568 -289.216)",
    fill: "#fff"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M749.68,326.96l2.223.386,2.107.116,3.388-1.082Z",
    transform: "translate(-695.299 -302.779)",
    fill: "#fff"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M828.63,283.174l2.766.464,1.745-.748Z",
    transform: "translate(-768.522 -262.434)",
    fill: "#fff"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M769.9,474.71c.119.1.691.446.691.446l2.591-.32Z",
    transform: "translate(-714.052 -440.383)",
    fill: "#fff"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M782.59,485.766l3.724.238s2-1.014,1.965-1.014S782.59,485.766,782.59,485.766Z",
    transform: "translate(-725.821 -449.92)",
    fill: "#fff"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M1235.86,447.38v.284l4.486.175Z",
    transform: "translate(-1146.212 -415.029)",
    fill: "#fff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M1245.84,270.95c.026.116.284,1.741.284,1.741l5.585-.52-5.869-1.22Z",
    transform: "translate(-1155.468 -251.358)",
    fill: "#fff"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M1456.49,352.61l1.164.458,3.646-.458Z",
    transform: "translate(-1350.837 -327.112)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogox2);
export default __webpack_public_path__ + "static/media/Logox2.9928b1fab0ed09eb94683ce06959aa62.svg";
export { ForwardRef as ReactComponent };